import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { TABLET_WIDTH } from '~~elements/Const';
import { LeagueResource } from '~~apis/resource';
import Button from '~~elements/Button';
import Multilingual from '~~utils/Multilingual';
import LeagueHeader from './LeagueHeader';
import LeagueSeasonHeader from './LeagueSeasonHeader';
import { Link } from 'react-router-dom';
import moment from 'moment';

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  letter-spacing: 1px;
  padding: 2rem 0;

  .create-tournament-section {
    width: 100%;
    border-top: 1px solid #eee;
    margin: 1rem 0 2rem 0;
    padding: 1rem 0 0;
  }

  @media (max-width: ${TABLET_WIDTH}) {
    align-items: center;
  }
`;

const OrganizerTournamentManagement = ({ leagues }) => {
  const [leagueIndex, setLeagueIndex] = useState(-1);

  const [seasons, setSeasons] = useState([]);
  const [seasonIndex, setSeasonIndex] = useState(-1);

  const [season, setSeason] = useState(null);

  useEffect(() => {
    setSeasons([]);
    if (!leagues[leagueIndex]) {
      return;
    }

    LeagueResource.getLeagueWithSeasons({ leagueUniqid: leagues[leagueIndex].info.uniqid })
      .then(({ data }) => {
        setSeasons([...data.seasons]);
      })
      .catch(() => {});
  }, [leagueIndex, leagues]);

  useEffect(() => {
    setSeason(null);
    if (!seasons[seasonIndex]) {
      return;
    }

    setSeason(seasons[seasonIndex]);
  }, [seasonIndex, seasons]);

  const getSeasonSummary = () => {
    if (!season) {
      return <></>;
    }

    return (
      <>
        <div>
          {`賽事期間：`}
          {moment(season.start_at).format('YYYY/MM/DD')}
          {` - `}
          {moment(season.end_at).format('YYYY/MM/DD')}
        </div>
        <div>
          {`賽事型態：`}
          {Multilingual(`TOURNAMENT.TYPE_${season.type}`)}
        </div>
        {/* <div>
          {`註冊時間：`}
          {!season.config.open_registration
            ? `本賽季不開放球隊自行註冊`
            : formatDate(new Date(season.config.player_registration.start_at), 'yyyy/MM/dd') +
              ` - ` +
              formatDate(new Date(season.config.player_registration.end_at), 'yyyy/MM/dd')}
        </div> */}
        <Link to={`/organizer/${leagues[leagueIndex].info.uniqid}/tournament/${season.uniqid}/basic`}>
          <Button color="blue">管理頁面</Button>
        </Link>
      </>
    );
  };

  return (
    <StyledDiv>
      {leagues.length > 0 && (
        <LeagueHeader leagues={leagues} leagueIndex={leagueIndex} setLeagueIndex={setLeagueIndex} />
      )}
      {seasons.length > 0 && (
        <LeagueSeasonHeader seasons={seasons} seasonIndex={seasonIndex} setSeasonIndex={setSeasonIndex} />
      )}
      {getSeasonSummary()}
      {leagues[leagueIndex] && (
        <div className="create-tournament-section">
          <Link to={`/organizer/${leagues[leagueIndex].info.uniqid}/create_tournament/basic`}>
            <Button color="red" width="unset">
              新建賽事
            </Button>
          </Link>
        </div>
      )}
    </StyledDiv>
  );
};

export default OrganizerTournamentManagement;
